export default "__VITE_ASSET__DWPDgZZ0__"